var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{staticClass:"status-badge",class:("text-" + _vm.statusColor),attrs:{"pill":"","variant":"light"}},[_vm._v(_vm._s(_vm.statusList.find(function (item) { return item.number == this$1.selectedStatusNumber; }) ? _vm.statusList.find(function (item) { return item.number == this$1.selectedStatusNumber; }).name : ""))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }